module.exports = __webpack_public_path__ + "img/detail.02f53e7e.svg";